"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _messaging = require("../../constants/messaging.types");

var _VidyardField = _interopRequireDefault(require("./fields/VidyardField"));

var styles = {
  formLabel: {
    fontSize: '1rem',
    color: 'primary.main',
    fontWeight: 700
  },
  note: {
    fontSize: '0.875rem',
    color: 'grey.main',
    fontWeight: 400
  }
};

var VideoDataController = function VideoDataController(_ref) {
  var control = _ref.control,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var _useController = (0, _reactHookForm.useController)({
    control,
    name: "".concat(_messaging.MessagingDataFields.VideoData, ".").concat(_messaging.VideoDataFields.Type)
  }),
      typeField = _useController.field;

  var _useController2 = (0, _reactHookForm.useController)({
    control,
    name: "".concat(_messaging.MessagingDataFields.VideoData, ".").concat(_messaging.VideoDataFields.Vidyard)
  }),
      onVidyardChange = _useController2.field.onChange;

  var _useController3 = (0, _reactHookForm.useController)({
    control,
    name: "".concat(_messaging.MessagingDataFields.VideoData, ".").concat(_messaging.VideoDataFields.Embed)
  }),
      onEmbedChange = _useController3.field.onChange;

  var _useController4 = (0, _reactHookForm.useController)({
    control,
    name: "".concat(_messaging.MessagingDataFields.VideoData, ".").concat(_messaging.VideoDataFields.Embed, ".").concat(_messaging.VideoDataEmbedFields.VideoUrl)
  }),
      _useController4$field = _useController4.field,
      embedVideoUrlValue = _useController4$field.value,
      onEmbedVideoUrlChange = _useController4$field.onChange,
      error = _useController4.fieldState.error;

  var typeFieldValue = typeField.value;
  (0, _react.useEffect)(function () {
    if (typeFieldValue !== _messaging.MessageVideoType.Vidyard) {
      onVidyardChange(null);
    }

    if (typeFieldValue !== _messaging.MessageVideoType.Embed) {
      onEmbedChange(null);
    }
  }, [typeFieldValue, onVidyardChange, onEmbedChange, onEmbedVideoUrlChange]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.FormLabel, {
    sx: styles.formLabel
  }, "Embed Video Content on the Landing Page?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.note
  }, "Note: the landing page will include your message subject & video, while your email will contain the message above."), /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    value: typeField.value || '',
    onChange: function onChange(event) {
      return typeField.onChange(event.target.value || null);
    }
  }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    disabled: disabled,
    value: "",
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      color: "primary"
    }),
    label: "No video"
  }), /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    disabled: disabled,
    value: _messaging.MessageVideoType.Vidyard,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      color: "primary"
    }),
    label: "Add or record a Vidyard video"
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: typeField.value === _messaging.MessageVideoType.Vidyard,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_VidyardField.default, {
    control: control,
    disabled: disabled
  })), /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    disabled: disabled,
    value: _messaging.MessageVideoType.Embed,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      color: "primary"
    }),
    label: "Embed a video link"
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: typeField.value === _messaging.MessageVideoType.Embed,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    ml: 4
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    value: embedVideoUrlValue !== null && embedVideoUrlValue !== void 0 ? embedVideoUrlValue : '',
    disabled: disabled,
    label: "Set default landing page video (URL)",
    variant: "outlined",
    error: !!(error !== null && error !== void 0 && error.message),
    helperText: error === null || error === void 0 ? void 0 : error.message,
    onChange: onEmbedVideoUrlChange
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.EmbedVideoTip, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }))))));
};

var _default = VideoDataController;
exports.default = _default;